/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiTagsQueryResponse, GetApiTagsQueryParams, GetApiTags400, GetApiTags401, GetApiTags403, GetApiTags500 } from "../../types/GetApiTags.ts";
import { getApiTagsQueryResponseSchema } from "../../zod/TagSchemas/getApiTagsSchema.ts";

function getGetApiTagsUrl() {
  const res = { method: 'GET', url: `/api/tags` as const }  
  return res
}

/**
 * @summary Получение списка жанров
 * {@link /api/tags}
 */
export async function getApiTags({ params }: { params?: GetApiTagsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiTagsQueryResponse, ResponseErrorConfig<GetApiTags400 | GetApiTags401 | GetApiTags403 | GetApiTags500>, unknown>({ method : "GET", url : getGetApiTagsUrl().url.toString(), params, ... requestConfig })  
  return getApiTagsQueryResponseSchema.parse(res.data)
}